<template>
    <div class="tw-flex tw-items-center tw-justify-end tw-ml-10" :class="{'tw-text-red-500': timeRunningOut}">
        <i class="fa fa-clock tw-pr-2"></i>
        {{ timer }}
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import moment from 'moment';

    export default {
        name: "Timer",

        props: ['quizSettings'],

        computed: {
            ...mapState('quiz',
                [
                    'timer_on',
                    'timer',
                    'quiz_start_time',
                    'stop_timer',
                    'quiz_finished'
                ]
            ),

            timeRunningOut() {
                return this.timer_started && this.timer.substr(3, 2) === '00' && this.timer.substr(0, 2) === '00';
            }
        },

        data() {
            return {
                interval: "",
                timer_started: false,
            }
        },

        mounted() {
            //get the time now + an hour
            let started_timer = moment(this.quiz_start_time,"YYYY-MM-DD HH:mm:ss");
            let future = started_timer.add(this.quizSettings.timer, 'minutes').format('YYYY-MM-DD HH:mm:ss');

            let future_format = moment(future).format('HH:mm:ss');

			const inPast = moment().isAfter(future);

            this.$store.commit('quiz/getTimeLeft', !inPast ? future : moment());

			if (inPast) {
				this.$store.commit('quiz/timerhasPassed',true);
			} else {
				this.timer_started = true;

				//every second, repeat the function
				this.interval = setInterval(() => {
					this.$store.commit('quiz/getTimeLeft', future);

					// If the quiz has ended show the time left
					if(this.stop_timer){
						clearInterval(this.interval);
					}

					// If the timer is finished end the quiz
					if(this.timer > future_format){
						//if the quiz isn't finished, show time ran out screen
						if(!this.quiz_finished) {
							this.$store.commit('quiz/timerhasPassed',true);
						}

						//clear the timer
						clearInterval(this.interval);
					}
				}, 1000);
			}
        },
    }
</script>

<style scoped>

</style>